import React, { useEffect} from "react";
import ReactDatatable from "@ashvin27/react-datatable";

interface Props {
  config: any;
  records: any[];
  columns: any[];
  dynamic?: boolean;
  total_record?: number;
  onChange?: (data: any) => void;
  className?: string;
}

export const SafeDatatable: React.FC<Props> = ({
  config,
  records,
  columns,
  dynamic = true,
  total_record = 0,
  onChange,
  className,
}) => {
  // dispara um clique real (simula clique no link de página)
  const clickEl = (el: Element | null) => {
    if (!el) return false;
    (el as HTMLElement).dispatchEvent(
      new MouseEvent("click", { bubbles: true, cancelable: true, view: window })
    );
    return true;
  };
  
  const tryClickPage = (value: string): boolean => {
    const root = document.querySelector(".dataTables_paginate") || document;
    const link7 = Array.from(
      root.querySelectorAll<HTMLAnchorElement>(".page-link")
    ).find((a) => (a.textContent || "").trim() === value);
    return clickEl(link7 || null);
  };

  useEffect(() => {
    const onDotsClick = (event: Event) => {
      const target = event.target as HTMLElement;

      // só trata o botão "..."
      if (
        !target?.classList.contains("page-link") ||
        (target.textContent || "").trim() !== "..."
      ) {
        return;
      }

      // impede o handler original da lib
      event.preventDefault();
      event.stopImmediatePropagation();

      // pega o <li> correspondente ao "..."
      const liDots = target.closest("li.page-item");
      if (!liDots) return;

      // tenta pegar o número anterior (antes dos "...")
      const prevLi = liDots.previousElementSibling;
      const prevText = (prevLi?.textContent || "").trim();
      const prevNum = /^\d+$/.test(prevText) ? Number(prevText) : null;

      const nextLi = liDots.nextElementSibling;
      const nextText = (nextLi?.textContent || "").trim();
      const nextNum = /^\d+$/.test(nextText) ? Number(nextText) : null;

      // if (prevNum) {
      //   console.log("📄 Número anterior aos ...:", prevNum);
      //   console.log("📄 Número posterior aos ...:", nextNum);

      // } else {
      //   console.log("⚠️ Nenhum número anterior encontrado");
      // }

      // tenta clicar no número anterior se já existir visível
      if (prevNum == 1)
      {
        if (tryClickPage(nextNum.toString())) return;
      } else{
        if (tryClickPage(prevNum.toString())) return;
      }

      // se ainda não estiver visível, força a navegação lógica (dados)
      const perPage = Number(config?.records_pages ?? 10);
      if (typeof onChange === "function") {
          onChange({
          page_number: 7,
          page_size: perPage
        });
      }
    };

    // intercepta cliques nos "..." antes do ReactDatatable processar
    document.addEventListener("click", onDotsClick, true);
    return () => document.removeEventListener("click", onDotsClick, true);
  }, [config, onChange]);

  return (
    <ReactDatatable
      config={config}
      records={records}
      columns={columns}
      dynamic={dynamic}
      total_record={total_record}
      onChange={onChange}
      className={className}
    />
  );
};
